// Lightweight, dependency-free HTML sanitizer for rendering user-authored email/signature
// HTML that other users may view (defends against pasted <script>/<img onerror>/javascript: etc.).
// Preserves formatting tags, inline styles, lists, and links.
export function sanitizeHtml(dirty) {
  if (!dirty) return '';
  const tpl = document.createElement('template');
  tpl.innerHTML = dirty;
  const banned = new Set(['script', 'iframe', 'object', 'embed', 'style', 'link', 'meta', 'base', 'form', 'input', 'button', 'svg']);
  const nodes = [];
  const walker = document.createTreeWalker(tpl.content, NodeFilter.SHOW_ELEMENT);
  let n = walker.nextNode();
  while (n) { nodes.push(n); n = walker.nextNode(); }
  nodes.forEach((el) => {
    if (banned.has(el.tagName.toLowerCase())) { el.remove(); return; }
    Array.from(el.attributes).forEach((attr) => {
      const name = attr.name.toLowerCase();
      const val = (attr.value || '').replace(/\s+/g, '').toLowerCase();
      if (name.startsWith('on')) el.removeAttribute(attr.name);
      else if ((name === 'href' || name === 'src' || name === 'xlink:href') && val.startsWith('javascript:')) el.removeAttribute(attr.name);
    });
  });
  return tpl.innerHTML;
}

export default sanitizeHtml;
